import React, { FC } from 'react';
import { MemberType } from 'api/models';
import { PlaceholderAvatar } from 'components/molecules/placeholder-avatar';
import { TeamAsLeafResource } from 'components/organisms/resource-management/resource-types';
import { NameCell } from 'components/organisms/timesheets/common/cells/name-cell';
import { usePlaceholderValueHelpers } from 'utils/placeholders';
import { NameWithCompanyInfo } from './component';
import { TeamWrapperWithActions } from './team-wrapper-with-actions';

type Props = Omit<TeamAsLeafResource, 'id' | 'type' | 'totalAllocation'> & {
  softAllocationsEnabled: boolean;
  autoAllocation: boolean;
  onFindMember: () => void;
  onEditTeam: () => void;
  onDeleteAllocations: () => void;
  onConvertAllocations: (toSoft: boolean) => void;
  onTeamRemoval: (projectId: number, teamId: number) => void;
};

export const TeamCellForProjectsView: FC<Props> = ({
  teamName,
  projectId,
  teamId,
  softAllocationsEnabled,
  onFindMember,
  onEditTeam,
  onDeleteAllocations,
  onConvertAllocations,
  onTeamRemoval,
  autoAllocation,
  userList,
  companyList,
}) => {
  const { getResponsibleCompany } = usePlaceholderValueHelpers();
  const responsibleCompany = getResponsibleCompany({
    teamId,
    teamName,
    companyList,
    userList,
    teamType: MemberType.Native,
  });

  return (
    <TeamWrapperWithActions
      projectId={projectId}
      teamId={teamId}
      softAllocationsEnabled={softAllocationsEnabled}
      onFindMember={onFindMember}
      onEditTeam={onEditTeam}
      onTeamRemoval={onTeamRemoval}
      onDeleteAllocations={onDeleteAllocations}
      onConvertAllocations={onConvertAllocations}
      autoAllocateProps={{
        autoAllocation,
        showIcon: false,
      }}
    >
      <NameCell
        logo={
          <PlaceholderAvatar
            isCustomerRole={false}
            name={teamName}
            companyLogoUrl={responsibleCompany?.companyLogoUrl}
          />
        }
        primaryText={
          <NameWithCompanyInfo
            name={teamName}
            company={responsibleCompany}
            showCompanyInfo={responsibleCompany != null}
          />
        }
      />
    </TeamWrapperWithActions>
  );
};
